import {
    ReportData,
    ReportGroup, ReportTemplate
} from "@/model/models";
import apiClient from '@/utils/api-client'
import { cachedInSession, SESSION_CACHE_KEYS } from '@/utils/session-cache'

class ReportService {
    // The menu's report list only changes when the BE's report config does, so it is fetched
    // once per tab session (sessionStorage) instead of on every page. Cleared on sign-in/out
    // and by the "clear static cache" button (see utils/session-cache).
    public getReportGroups () {
        return cachedInSession(SESSION_CACHE_KEYS.reportGroups,
            () => apiClient.get('/api/v1/reports/list').then((res) => res.data.groups || []))
            .then((groups: any[]) => groups.map((data: any) => new ReportGroup(data)))
            .catch((error) => {
                console.log(error)
                throw error
            })
    }

    public getReport (reportId: string) {
        return new Promise<ReportTemplate>((resolve, reject) => {
            apiClient.get('/api/v1/reports/template/' + reportId).then((res) => {
                resolve(new ReportTemplate(res.data))
            }).catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    }

    public getData (reportId: string, params: string) {
        return new Promise<ReportData[]>((resolve, reject) => {
            apiClient.get('/api/v1/reports/data/' + reportId + (params && params.length ? '?' + params : '')).then((res) => {
                resolve(res.data.datasets?.map((data: any) => new ReportData(data)))
            }).catch((error) => {
                console.log(error)
                reject(error)
            })
        })
    }
}

export default new ReportService ()